var render = function render(){var _vm=this,_c=_vm._self._c;return _c('x-ajax-dropdown',{attrs:{"allowEmpty":true,"blacklist":_vm.blacklist,"disabled":_vm.isLoading,"placeholder":_vm.placeholder,"query":_vm.query,"url":`/api/group-statistic-templates`,"value":_vm.selectedResource,"label":"label","trackBy":"id"},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }